import { Component, OnInit } from '@angular/core';
import { DescuentosService } from 'src/app/shared/services/descuentos/descuentos.service';
import { OpenPopupService } from 'src/app/shared/services/open_popup/open-popup.service';
import { Router, NavigationEnd } from '@angular/router';


interface Suma {
  value: number;
  viewValue: string;
}

interface Resta {
  value: number;
  viewValue: string;
}

@Component({
  selector: 'app-popup-dto',
  templateUrl: './popup-dto.component.html',
  styleUrls: ['./popup-dto.component.css']
})
export class PopupDtoComponent implements OnInit {
  selectedSuma = 0;
  selectedResta = 0;
  sum: any;
  rest: any;

  id: any;
  nombre: any;
  dto: any;
  curso: any;
  salon: any;
  fechaInicio: any;
  estado: any;
  modalidad: any;
  cupoMinimo: any;
  cupoMaximo: any;
  inscritos: any;
  cargaHoraria: any;
  horario: any;
  categoria: any;


  sumas: Suma[] = [
    { value: 0, viewValue: '-- Sumar descuento --' },
    { value: 5, viewValue: '5' },
    { value: 10, viewValue: '10' },
    { value: 15, viewValue: '15' },
    { value: 20, viewValue: '20' },
    { value: 25, viewValue: '25' },
    { value: 30, viewValue: '30' },
    { value: 35, viewValue: '35' },
    { value: 40, viewValue: '40' },
    { value: 45, viewValue: '45' },
    { value: 50, viewValue: '50' }
  ];

  restas: Resta[] = [
    { value: 0, viewValue: '-- Restar descuento --' },
    { value: 5, viewValue: '5' },
    { value: 10, viewValue: '10' },
    { value: 15, viewValue: '15' },
    { value: 20, viewValue: '20' },
    { value: 25, viewValue: '25' },
    { value: 30, viewValue: '30' },
    { value: 35, viewValue: '35' },
    { value: 40, viewValue: '40' },
    { value: 45, viewValue: '45' },
    { value: 50, viewValue: '50' }
  ];

  constructor(private descuentosService: DescuentosService, private popupService: OpenPopupService, private router: Router) { }

  ngOnInit(): void {
    this.id = this.popupService.id;
    this.nombre = this.popupService.nombre;
    this.dto = this.popupService.descuento;
    this.curso = this.popupService.curso;
    this.salon = this.popupService.salon;
    this.fechaInicio = this.popupService.fechaInicio;
    this.estado = this.popupService.estado;
    this.modalidad = this.popupService.modalidad;
    this.cupoMinimo = this.popupService.cupoMinimo;
    this.cupoMaximo = this.popupService.cupoMaximo;
    this.inscritos = this.popupService.inscritos;
    this.cargaHoraria = this.popupService.cargaHoraria;
    this.horario = this.popupService.horario;
    this.categoria = this.popupService.categoria;
  }


  sumaID(sum) {
    this.selectedSuma = sum;
    this.selectedResta = 0;
  }

  restaID(rest) {
    this.selectedResta = rest;
    this.selectedSuma = 0;
  }

  public editDto() {
    this.descuentosService.insertDescuento(this.id,
      this.fechaInicio,
      this.estado,
      this.cupoMinimo,
      this.cupoMaximo,
      this.horario,
      this.fechaActual(),
      this.dto + this.selectedSuma,
      this.selectedResta,
      this.categoria).subscribe(
        data => {
          var response = data;
          console.log(response);
          location.reload();

        },
        err => {
          console.log(err);
          this.router.navigate(['login']);
        }
      );;
  }

  public fechaActual() {
    var f = new Date();
    if ((f.getMonth() + 1) < 10 && (f.getDate()) < 10) {
      return (f.getFullYear() + "-" + "0" + (f.getMonth() + 1) + "-" + "0" + f.getDate());
    }

    else {
      if ((f.getMonth() + 1) < 10) {
        return (f.getFullYear() + "-" + "0" + (f.getMonth() + 1) + "-" + f.getDate());
      }
      if ((f.getDate()) < 10) {
        return (f.getFullYear() + "-" + (f.getMonth() + 1) + "-" + "0" + f.getDate());
      }
    }


  }

}
